import api from "@/api/api";
import { ApiKomef } from ".";
import getApiResponse from "@/api/apiResponse";

export interface IKomefLoginInfo {
  LinkId: string;
}

export interface IKomefLoginResult {
  roleName: string;
  accessToken: string;
  hcode: string;
  dcode: string;
}

const KomefAccountService = {
  login: async (linkId: string) => {
    const postData: IKomefLoginInfo = { LinkId: linkId };
    console.log("login.postData=>", postData);
    const res = await api.post(ApiKomef.LOGIN, postData);
    return getApiResponse<IKomefLoginResult>(res);
  },
};

export default KomefAccountService;
